const LEGACY_ACTIVE_FILE_ID_PARAM = "activeProjectId";
export const ACTIVE_FILE_ID_PARAM = "activeFileId";
export const REDIRECT_TO_AFTER_LOGIN_PARAM = "redirect_to_after_login";

export const THEME_ID_PARAM = "themeId";

export const PLAN_SIGNUP_PARAM = "plan_signup";

export const getCurrentPath = () =>
  window.location.pathname + window.location.search;

export const getUrlParam = (param: string) => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get(param);
};

export const removeUrlParam = (param: string) => {
  const queryParams = new URLSearchParams(window.location.search);
  queryParams.delete(param);
  const newParamsString =
    queryParams.size > 0 ? "?" + queryParams.toString() : "";
  window.history.replaceState(
    {},
    "",
    window.location.pathname + newParamsString,
  );
};

export const getActiveFileIdUrlParam = () => {
  return (
    getUrlParam(ACTIVE_FILE_ID_PARAM) ||
    getUrlParam(LEGACY_ACTIVE_FILE_ID_PARAM)
  );
};

export const addParam = (
  url: string | URL,
  paramName: string,
  paramValue: string | null | undefined,
) => {
  if (!paramValue) {
    return url;
  } else {
    // Handle relative URLs by using a dummy base
    const isRelative = typeof url === "string" && url.startsWith("/");
    const urlObj = isRelative ? new URL(url, "http://dummy.com") : new URL(url);
    urlObj.searchParams.set(paramName, paramValue);
    // Return relative path if input was relative
    return isRelative
      ? urlObj.pathname + urlObj.search + urlObj.hash
      : urlObj.toString();
  }
};
